import React, {useState, useEffect} from 'react';
import {StyleSheet, View, TouchableOpacity} from 'react-native';
import {Typography, Badge} from 'src/components';
import {colors} from 'src/assets';
import {User, Price, OfferAvatar} from './components';
import {IService} from 'src/domains';
import {UserStatus} from 'src/domains';
import {trim} from 'src/utils/string';

export type OfferListItemProps = {
  offer: IService;
  onPress?: () => void;
};

export const OfferListItem: React.FC<OfferListItemProps> = ({
  offer,
  onPress,
}) => {
  const [status, setStatus] = useState<UserStatus>(
    offer.owner?.status || UserStatus.LOGOUT,
  );

  useEffect(() => {
    setStatus(offer.owner?.status || UserStatus.LOGOUT);
  }, [offer]);
  return (
    <TouchableOpacity
      style={styles.container}
      onPress={() => (onPress ? onPress() : {})}>
      <View style={styles.content}>
        <Typography variant={'h1'} text={trim(offer.title || '', 32, '...')} />
        {offer.category?.title ? (
          <Badge
            containerStyle={styles.badge}
            text={offer.category?.title}
            color={colors.chokuGray5}
          />
        ) : null}
        <View style={styles.priceContainer}>
          <User
            source={offer.owner?.image ? {uri: offer.owner?.image} : undefined}
            status={status}
            name={trim(offer.owner?.name || '', 32, '...')}
            isVerified={offer.owner?.identificationStatus === 'APPROVED'}
          />
          <Price value={offer.price || 0} />
        </View>
      </View>
      <OfferAvatar
        source={offer.mainImageUrl ? {uri: offer.mainImageUrl} : undefined}
        status={status}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: colors.white,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginRight: 24,
  },
  badge: {
    marginTop: 8,
  },
  priceContainer: {
    // flex: 1,
    // width: '100%',
    marginTop: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  offerImageContainer: {},
});
